import React, { Component } from 'react';
import { toast } from 'react-toastify';
import EditableSqlReportRow from './EditableSqlReportRow';
import FormError from 'components/FormError';
import ReportCrontabModal from './ReportCrontabModal';

const prepareEmailAddresses = (email_addresses) => {
  if (!email_addresses) {
    return '';
  }

  if (typeof email_addresses === 'object' && email_addresses.length) {
    return email_addresses.join(', ');
  }

  return email_addresses;
};

class SqlReport extends Component {
  state = {
    showCrontabModal: false,
  };

  openCrontabModal = () => {
    this.setState({ showCrontabModal: true });
  };

  closeCrontabModal = () => {
    this.setState({ showCrontabModal: false });
  };

  handleSaveField = (key, value) => {
    const { sqlReport, setLoading, updateSqlReport } = this.props;
    setLoading(true);
    let tranformedValue = value;
    if (key === 'email_addresses') {
      tranformedValue = value.split(',').map((email) => email.trim());
    }
    updateSqlReport(sqlReport.id, { [key]: tranformedValue })
      .then(() => {
        setLoading(false);
        toast.success('Report updated');
      })
      .catch((e) => {
        if (e.errors) {
          let transformedError = e.errors;
          const keys = Object.keys(transformedError);
          keys.forEach((key) => {
            if (Array.isArray(transformedError[key])) {
              transformedError[key] = transformedError[key].join('; ');
            }
          });
          toast.error(<FormError error={transformedError} />);
        } else {
          toast.error(<FormError error={e} />);
        }
        setLoading(false);
      });
  };

  render() {
    const { sqlReport, updateSqlReport } = this.props;
    const { showCrontabModal } = this.state;

    if (!sqlReport) {
      return null;
    }

    const {
      id,
      title,
      report_format,
      enabled,
      email_addresses,
      email_subject,
      email_only_with_results,
      google_spreadsheet_id,
      google_spreadsheet_url,
      google_spreadsheet_is_template,
      crontab_schedule,
    } = sqlReport;

    return (
      <div>
        <table className="table sql-report-table">
          <tbody>
            <tr>
              <th>Id</th>
              <td>{id}</td>
              <td></td>
            </tr>
            <tr>
              <th>Title</th>
              <td>{title}</td>
              <td></td>
            </tr>
            <tr>
              <th>Report format</th>
              <td>{report_format}</td>
              <td></td>
            </tr>
            <EditableSqlReportRow
              label="Enabled"
              name="enabled"
              value={enabled}
              type="select"
              save={this.handleSaveField}
            />
            <EditableSqlReportRow
              label="Email addresses"
              name="email_addresses"
              value={prepareEmailAddresses(email_addresses) || ''}
              type="input"
              save={this.handleSaveField}
              editTooltip="*Email Addresses should be a comma separated list"
            />
            <EditableSqlReportRow
              label="Email subject"
              name="email_subject"
              value={email_subject || ''}
              type="input"
              save={this.handleSaveField}
            />
            <EditableSqlReportRow
              label="Email only with results"
              name="email_only_with_results"
              value={email_only_with_results}
              type="select"
              save={this.handleSaveField}
            />
            <EditableSqlReportRow
              label="Google spreadsheet id"
              name="google_spreadsheet_id"
              value={google_spreadsheet_id || ''}
              type="input"
              save={this.handleSaveField}
            />
            <EditableSqlReportRow
              label="Google spreadsheet is template"
              name="google_spreadsheet_is_template"
              value={google_spreadsheet_is_template}
              type="select"
              save={this.handleSaveField}
            />
            <tr>
              <th>Google spreadsheet url</th>
              <td>{google_spreadsheet_url}</td>
              <td></td>
            </tr>
            <tr>
              <th>Crontab schedule</th>
              <td>
                {crontab_schedule && crontab_schedule.id && (
                  <span>
                    <span>Id: {crontab_schedule.id}</span>
                    <br />
                    <span>Minute: {crontab_schedule.minute}</span>
                    <br />
                    <span>Hour: {crontab_schedule.hour}</span>
                    <br />
                    <span>Day of week: {crontab_schedule.day_of_week}</span>
                    <br />
                    <span>Day of month: {crontab_schedule.day_of_month}</span>
                    <br />
                    <span>Month of year: {crontab_schedule.month_of_year}</span>
                    <br />
                    <span>Timezone: {crontab_schedule.timezone}</span>
                  </span>
                )}
              </td>
              <td
                style={{
                  textAlign: 'right',
                  minWidth: '167px',
                  width: '167px',
                }}
              >
                <img
                  style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                  onClick={this.openCrontabModal}
                  src="/images/pen-to-square-regular.svg"
                  alt="edit"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <ReportCrontabModal
          isOpen={showCrontabModal}
          closeModal={this.closeCrontabModal}
          updateSqlReport={updateSqlReport}
          sqlReport={sqlReport}
        />
      </div>
    );
  }
}

export default SqlReport;
